import { useContext } from 'react';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { FetchBrandThemingContext } from '../Context';
import { type BrandingResponse } from '../interfaces';

export const useFetchBrandingQuery = (options: Options = {}) => {

  const fetchBranding = useContext(FetchBrandThemingContext);

  return useQuery({
    queryKey: [`get:groups/branding`, fetchBranding],
    queryFn: () => {
      return fetchBranding();
    },
    ...options,
  });
};

type Options = Omit<UseQueryOptions<BrandingResponse>, 'queryKey' | 'queryFn'>;